import React, { useRef, useEffect } from 'react';
import { connect } from 'react-redux';

import { updateOrder, deleteOrder } from 'actions/orders';
import { fetchCouncils, fetchCouncil } from 'actions/councils';
import { councilSelector, addressDisplaySelector } from 'selectors/order-create';

import LoadingSpinner from 'components/LoadingSpinner';

import {
  LoadingContain
} from './CreateStyled';

export const StepCertificates = ({
  council,
  loading,
  setStep,
  order,
  onClose,
  fetchCouncils,
  deleteOrder,
  updateOrder,
  fetchCouncil,
  renderActions,
  selectedCertificate
}) => {
  const fetchCouncilRef = useRef(null);

  //get councils
  useEffect(() => {
    fetchCouncils();
  }, [ fetchCouncils ])

  //fetch council
  useEffect(() => {
    if (council && !fetchCouncilRef.current) {
      fetchCouncilRef.current = true;
      fetchCouncil(council.id);
    }
  }, [ fetchCouncil, council ])

  //check length to avoid selecing section 7 (yucky)
  useEffect(
    function selectItem () {
      if (council && council.items) {
        var section187 = council.items.find(i => 
          i.document_types.length === 1 && 
          i.document_types[0] === order.createFrom.itemType
        )

        if (section187) {
          updateOrder({ selected_certificate: section187.id });
          setStep(6) //checkout step (6) for council search orders yucky also;
          onClose();
        } else {
          //reset if issues
          deleteOrder()
          setStep(0)
          onClose();
        }
      }
    }, 
    [ council, order, updateOrder, setStep, onClose ]
  )

  return (
    <LoadingContain>
      <LoadingSpinner />
    </LoadingContain>
  );
};

StepCertificates.defaultProps = {
  inputErrors: {},
  onValueChange: () => null
};

export default connect(
  (state) => ({
    session: state.session,
    council: councilSelector(state),
    loading: state.loading.loadingCouncil,
    addressDisplay: addressDisplaySelector(state),
    selectedCouncil: state.pendingOrder.pending.selected_council
  }),
  {
    dispatchOrderUpdate: updateOrder,
    dispatchGetCouncil: fetchCouncil,
    dispatchGetCouncils: fetchCouncils,
    dispatchOrderDelete: deleteOrder
  })(props => <StepCertificates 
    {...props}
    updateOrder={props.dispatchOrderUpdate}
    fetchCouncil={props.dispatchGetCouncil}
    deleteOrder={props.dispatchOrderDelete}
    fetchCouncils={props.dispatchGetCouncils}
  />
);
